// Modules
import Trivia from "../components/Trivia";
import Time from "../components/Time";

// Service
import { triviaService } from "../services/api";
const api = new triviaService();
declare global {
    interface Window {
        prefix: any,
    }
  }
export const page = async () => {
    
    const triviaTime = new Time();
    const triviaData: any = await api.getDataTrivia()
    console.log(triviaData);
    window.prefix = triviaData.prefix;
    if (triviaData) {
        new Trivia('#Trivia1', {
            welcomePage: false,
            nextButton: 'Siguiente',
            timer: triviaTime.milisecToSec(triviaData.milliseconds),
            questions: triviaData.questions,
            triviaPrefix: triviaData.prefix
        })
    }
}